"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _echarts = _interopRequireDefault(require("echarts"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _elementUi = require("element-ui");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('echarts/theme/macarons'); // echarts theme
var _default = exports.default = {
  components: (0, _defineProperty2.default)({
    CountTo: _vueCountTo.default
  }, _elementUi.Tooltip.name, _elementUi.Tooltip),
  props: {},
  data: function data() {
    return {
      colorPalette: (0, _index.colorPalette)(),
      delComma: _index.delComma,
      chart: null,
      // 饼状图
      device_type: -1,
      // equipData: {},
      // chartData: [],
      // chartTitle: [],
      // chartColumn: null,
      percentType: '0',
      // timeArr: [],
      deviceData: [{}, {}, {}, {}],
      drawLineData: {
        title: ['充电宝', '充电线', '充电桩', '套套机'],
        money: [0, 0, 0, 0],
        recharge: [0, 0, 0, 0],
        // 充值额数据
        num: [0, 0, 0, 0],
        aliPayNum: [0, 0, 0, 0],
        wechatNum: [0, 0, 0, 0],
        univalence: [0, 0, 0, 0],
        tips: [{
          name: '0元',
          coord: [0, 0]
        }, {
          name: '0元',
          coord: [1, 0]
        }, {
          name: '0元',
          coord: [2, 0]
        }, {
          name: '0元',
          coord: [3, 0]
        }]
      },
      money: {},
      search_agent_id: 0
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      // if(this.$store.getters.agentDevice.length > 0) this.getEquipData()
      if (this.$store.getters.agentDevice.length > 0) this.getDrawLineData(1);
      return this.$store.getters.deviceNameObj;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.getters.deviceKeyObj;
    }
  },
  mounted: function mounted() {
    var _this = this;
    // 获取金额（可提现）
    this.getMoney();
    // 获取设备数据-订单-充值及消费
    this.getDrawLineData(1);
    // 绘制图表
    this.$nextTick(function () {
      _this.drawLine();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    /**
     * 获取金额
     */
    drawLine: function drawLine() {
      this.chartColumn = _echarts.default.init(document.getElementById('chartLine'));
      this.chartColumn.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '15%',
          left: '2%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.drawLineData.title,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            interval: 0,
            //使x轴文字显示全
            textStyle: {
              color: "#000",
              fontSize: "12px"
            },
            inside: false

            // rotate: 20,
          }
        }],
        yAxis: [{
          type: 'value',
          axisLine: {
            //y轴样式
            show: false
          },
          axisLabel: {
            show: false,
            inside: false
          }
        }],
        series: [{
          name: '消费',
          type: 'bar',
          barWidth: '30%',
          barMinHeight: 2,
          // 设置柱条最小高度，确保数值大于0时能显示
          itemStyle: {
            color: new _echarts.default.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#74edb2'
            }, {
              offset: 0.5,
              color: '#68e8aa'
            }, {
              offset: 1,
              color: '#56e09d'
            }])
          },
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: function formatter(params) {
              // 显示标题和金额
              return params.value + '元' + '\n 消费';
            }
          },
          data: this.drawLineData.money
        }, {
          name: '充值',
          type: 'bar',
          barWidth: '30%',
          barMinHeight: 2,
          // 设置柱条最小高度，确保数值大于0时能显示
          itemStyle: {
            color: new _echarts.default.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#ffb777'
            }, {
              offset: 0.5,
              color: '#ffa44f'
            }, {
              offset: 1,
              color: '#ff9225'
            }])
          },
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: function formatter(params) {
              // 显示标题和金额
              return params.value + '元' + '\n充值';
            }
          },
          data: this.drawLineData.recharge
        }]
      });
    },
    /**
     * 订单统计切换
     */
    handleChange: function handleChange() {
      this.deviceData = [{}, {}, {}, {}];
      if (this.percentType == 0) {
        this.getDrawLineData(1);
      } else if (this.percentType == 1) {
        this.getDrawLineData(2);
      } else if (this.percentType == 2) {
        this.getDrawLineData(3);
      } else if (this.percentType == 3) {
        this.getDrawLineData(4);
      } else if (this.percentType == 4) {
        this.getDrawLineData(5);
      }
    },
    /**
     * 绘制折线图
     * @param money 订单金额
     * @param num 订单数量
     * @param zfbNum 支付宝
     * @param wxNum 微信
     * @param univalence 客单价
     */
    reBuildDrawLineData: function reBuildDrawLineData(money, num, zfbNum, wxNum, univalence) {
      var _this2 = this;
      // 处理消费额数据，保留原始值，0值也会显示（由于barMinHeight设置）
      this.drawLineData.money = [this.deviceData[0][money] || 0, this.deviceData[1][money] || 0, this.deviceData[2][money] || 0, this.deviceData[3][money] || 0];
      this.drawLineData.num = [this.deviceData[0][num], this.deviceData[1][num], this.deviceData[2][num], this.deviceData[3][num]];

      // 添加微信的处理
      this.drawLineData.wechatNum = [this.deviceData[0][wxNum] || 0, this.deviceData[1][wxNum] || 0, this.deviceData[2][wxNum] || 0, this.deviceData[3][wxNum] || 0];
      // 添加支付宝数据
      this.drawLineData.aliPayNum = [this.deviceData[0][zfbNum] || 0, this.deviceData[1][zfbNum] || 0, this.deviceData[2][zfbNum] || 0, this.deviceData[3][zfbNum] || 0];
      // 添加客单价数据
      this.drawLineData.univalence = [this.deviceData[0][univalence] || 0, this.deviceData[1][univalence] || 0, this.deviceData[2][univalence] || 0, this.deviceData[3][univalence] || 0];
      this.$nextTick(function () {
        _this2.drawLine();
      });
    },
    /**
     * 可提现金额
     */
    getMoney: function getMoney() {
      var _this3 = this;
      this.$get('agentapi/index').then(function (res) {
        _this3.money = res;
      });
    },
    /**
     * 获取设备数据-订单-充值
     * @param type
     * @returns {Promise<void>}
     */
    getDrawLineData: function () {
      var _getDrawLineData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
        var i;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              i = 1;
            case 1:
              if (!(i <= this.drawLineData.title.length)) {
                _context.next = 3;
                break;
              }
              _context.next = 2;
              return this.getDeviceData(i, type);
            case 2:
              i++;
              _context.next = 1;
              break;
            case 3:
              // 获取充值数据的独立请求
              this.getRechargeData(type);

              // 获取消费数据的独立请求
              if (type == 1) {
                this.reBuildDrawLineData('type_order_yesterday_amount', 'type_order_yesterday_num', 'yesterday_zfb_num', 'yesterday_wx_num', 'yesterday_univalence');
              } else if (type == 2) {
                this.reBuildDrawLineData('type_order_last_week_amount', 'type_order_last_week_num', 'last_zfb_week_num', 'last_wx_week_num', 'last_week_univalence');
              } else if (type == 3) {
                this.reBuildDrawLineData('type_order_this_week_amount', 'type_order_this_week_num', 'this_zfb_week_num', 'this_wx_week_num', 'this_week_univalence');
              } else if (type == 4) {
                this.reBuildDrawLineData('type_order_this_month_amount', 'type_order_this_month_num', 'this_zfb_month_num', 'this_wx_month_num', 'this_month_univalence');
              } else if (type == 5) {
                this.reBuildDrawLineData('type_order_last_month_amount', 'type_order_last_month_num', 'last_zfb_month_num', 'last_wx_month_num', 'last_month_univalence');
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDrawLineData(_x) {
        return _getDrawLineData.apply(this, arguments);
      }
      return getDrawLineData;
    }(),
    /**
     * 获取充值数据
     * @param type
     * @returns {Promise<void>}
     */
    getRechargeData: function () {
      var _getRechargeData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(type) {
        var _this4 = this;
        var rechargeData, query_date, formatDate, yesterday, yesterdayStr, lastWeekEnd, lastWeekStart, thisWeekStart, thisWeekEnd, thisMonthStart, thisMonthEnd, lastMonthStart, lastMonthEnd, today, todayStr, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 根据不同类型设置模拟的充值数据
              rechargeData = [0, 0, 0, 0];
              query_date = ""; // 格式化日期为 YYYY-MM-DD
              formatDate = function formatDate(date) {
                var year = date.getFullYear();
                var month = String(date.getMonth() + 1).padStart(2, '0');
                var day = String(date.getDate()).padStart(2, '0');
                return "".concat(year, "-").concat(month, "-").concat(day);
              };
              _t = type;
              _context2.next = _t === 1 ? 1 : _t === 2 ? 2 : _t === 3 ? 3 : _t === 4 ? 4 : _t === 5 ? 5 : 6;
              break;
            case 1:
              // 昨日
              yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              yesterdayStr = formatDate(yesterday);
              query_date = "".concat(yesterdayStr, " 00:00:01|").concat(yesterdayStr, " 23:59:59");
              return _context2.abrupt("continue", 7);
            case 2:
              // 上周(上周一到上周日)
              lastWeekEnd = new Date();
              lastWeekEnd.setDate(lastWeekEnd.getDate() - lastWeekEnd.getDay() - 1); // 上周日
              lastWeekStart = new Date(lastWeekEnd);
              lastWeekStart.setDate(lastWeekStart.getDate() - 6); // 上周一
              query_date = "".concat(formatDate(lastWeekStart), " 00:00:01|").concat(formatDate(lastWeekEnd), " 23:59:59");
              return _context2.abrupt("continue", 7);
            case 3:
              // 本周(本周一到今天)
              thisWeekStart = new Date();
              thisWeekStart.setDate(thisWeekStart.getDate() - thisWeekStart.getDay() + 1); // 本周一
              thisWeekEnd = new Date(); // 今天
              query_date = "".concat(formatDate(thisWeekStart), " 00:00:01|").concat(formatDate(thisWeekEnd), " 23:59:59");
              return _context2.abrupt("continue", 7);
            case 4:
              // 本月
              thisMonthStart = new Date();
              thisMonthStart.setDate(1); // 本月第一天
              thisMonthEnd = new Date(); // 今天
              query_date = "".concat(formatDate(thisMonthStart), " 00:00:01|").concat(formatDate(thisMonthEnd), " 23:59:59");
              return _context2.abrupt("continue", 7);
            case 5:
              // 上月
              lastMonthStart = new Date();
              lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
              lastMonthStart.setDate(1); // 上月第一天
              lastMonthEnd = new Date();
              lastMonthEnd.setDate(0); // 上月最后一天
              query_date = "".concat(formatDate(lastMonthStart), " 00:00:01|").concat(formatDate(lastMonthEnd), " 23:59:59");
              return _context2.abrupt("continue", 7);
            case 6:
              // 获取今日时间范围
              today = new Date();
              todayStr = formatDate(today);
              query_date = "".concat(todayStr, " 00:00:01|").concat(todayStr, " 23:59:59");
              return _context2.abrupt("continue", 7);
            case 7:
              // 初始化充值数据数组，索引对应设备类型: 0-充电宝, 1-充电线, 2-充电桩, 3-套套机
              rechargeData = [0, 0, 0, 0];
              _context2.next = 8;
              return this.$get('agentapi/data_overview/overview_project_type_amount', {
                query_date: query_date
              }).then(function (res) {
                // 根据返回的数据更新充值数据
                if (res && Array.isArray(res)) {
                  res.forEach(function (item) {
                    // 根据 project_type 确定数据应该放在哪个位置
                    // project_type: 0-充电宝, 1-充电线, 3-充电桩, 7-套套机
                    switch (item.project_type) {
                      case 0:
                        // 充电宝
                        rechargeData[0] = parseFloat(item.p_money) || 0;
                        break;
                      case 1:
                        // 充电线
                        rechargeData[1] = parseFloat(item.p_money) || 0;
                        break;
                      case 3:
                        // 充电桩
                        rechargeData[2] = parseFloat(item.p_money) || 0;
                        break;
                      case 7:
                        // 套套机
                        rechargeData[3] = parseFloat(item.p_money) || 0;
                        break;
                    }
                  });
                }
              }).catch(function (err) {
                console.error("获取充值数据失败:", err);
              });
            case 8:
              // 更新充值数据
              this.drawLineData.recharge = rechargeData;

              // 重新绘制图表以显示新数据
              this.$nextTick(function () {
                _this4.drawLine();
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getRechargeData(_x2) {
        return _getRechargeData.apply(this, arguments);
      }
      return getRechargeData;
    }(),
    /**
     * 设备数据 - 添加请求间隔避免HTTP/2协议错误
     * @param device_type
     * @param type
     * @returns {Promise<void>}
     */
    getDeviceData: function () {
      var _getDeviceData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(device_type, type) {
        var temp_device_type, res, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 50 * (device_type - 1));
              });
            case 1:
              temp_device_type = device_type;
              if (device_type == 1) {
                temp_device_type = 0;
              }
              if (device_type == 2) {
                temp_device_type = 1;
              }
              if (device_type == 3) {
                temp_device_type = 3;
              }
              if (device_type == 4) {
                temp_device_type = 7;
              }
              _context3.prev = 2;
              _context3.next = 3;
              return this.$get('agentapi/my_type_device_data', {
                device_type: temp_device_type,
                search_agent_id: this.search_agent_id,
                date_type: type
              });
            case 3:
              res = _context3.sent;
              this.deviceData[device_type - 1] = res;
              _context3.next = 5;
              break;
            case 4:
              _context3.prev = 4;
              _t2 = _context3["catch"](2);
              console.error("\u83B7\u53D6\u8BBE\u5907\u7C7B\u578B ".concat(device_type, " \u6570\u636E\u5931\u8D25:"), _t2);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function getDeviceData(_x3, _x4) {
        return _getDeviceData.apply(this, arguments);
      }
      return getDeviceData;
    }()
  }
};